export const enResources = {
  translation: {
    Onboarding: "Onboarding",
    Select: "Select",
    Add: "Add",
    Cancel: "Cancel",
    Next: "Next",
    Previous: "Previous",
    Submitted: "Submitted",
    Submit: "Submit",
    Confirm: "Confirm",
    Required: "Required",
    "See all": "See all",
    "Onboarding successful": "Onboarding successful",
    "Onboarding failed - contact evsupport@eplucon.nl":
      "Onboarding failed - contact evsupport@eplucon.nl",

    "Let's get started": "Let's get started",
    "Onboard your charger in just a few steps":
      "Onboard your charger in just a few steps",
    "Onboarding is now complete": "Onboarding is now complete",

    // Start
    "This onboarding tool is intended for new users of Monta. For expansion, please contact Eplucon.":
      "This onboarding tool is intended for new users of Monta. For expansion, please contact Eplucon.",

    // Side carousel
    "Onboard your charging station at Monta and you can start immediately. Monta gives you plenty of options to use your charging station the way you want. Determine your own rates and to whom which rate applies, or set free charging. It's all possible with Monta!":
      "Onboard your charging station at Monta and you can start immediately. Monta gives you plenty of options to use your charging station the way you want. Determine your own rates and to whom which rate applies, or set free charging. It's all possible with Monta!",

    // Tier options
    Basic: "Basic",
    "Charging at home, visitor can only charge with own Monta account. (Maximum 3 charging points)":
      "Charging at home, visitor can only charge with own Monta account. (Maximum 3 charging points)",
    Sponsored: "Sponsored",
    "Charging at home with automatic settlement between employer and employee.":
      "Charging at home with automatic settlement between employer and employee.",
    Commercial: "Commercieel",
    "The best solution for commercial charging for both companies and private individuals with all functionalities.":
      "The best solution for commercial charging for both companies and private individuals with all functionalities.",

    // Tier table
    Costs: "Costs",
    Subscription: "Subscription",
    "Paid charging session": "Paid charging session",
    "Free or sponsored charging session": "Free or sponsored charging session",
    "Basis (incl. VAT)": "Basis (incl. VAT)",
    Free: "Free",
    "0.24 starting rate and 7.5% per transaction":
      "0.24 starting rate and 7.5% per transaction",
    "0.24 starting rate, no transaction costs":
      "0.24 starting rate, no transaction costs",
    "Sponsored (excl. VAT)": "Sponsored (excl. VAT)",
    "€ 7,44": "€ 7,44",
    "0.20 starting rate and 7.5% per transaction":
      "0.20 starting rate and 7.5% per transaction",
    "0.20 starting rate, no transaction costs":
      "0.20 starting rate, no transaction costs",
    "Commercial (excl. VAT)": "Commercial (excl. VAT)",

    "Which option is best suited to your situation?":
      "Which option is best suited to your situation?",
    Compare: "Compare",

    // Tier Compare
    "Basic (incl. VAT) Max. 3 charging points)":
      "Basic (incl. VAT) Max. 3 charging points)",
    Employee: "Employee",
    Employer: "Employer",
    "€7.44 per month, per socket": "€7.44 per month, per socket",
    "Paid charging session costs": "Paid charging session costs",
    "0.24 starting rate and 15% transaction costs":
      "0.24 starting rate and 15% transaction costs",
    "0.20 starting rate and 7.5% transaction costs":
      "0.20 starting rate and 7.5% transaction costs",
    "Costs sponsored or free charging session":
      "Costs sponsored or free charging session",
    "Optional: 4G Connectivity": "Optional: 4G Connectivity",
    "€3.63 per month, per socket": "€3.63 per month, per socket",
    "€3.00 per month, per socket": "€3.00 per month, per socket",
    "Email support (In Monta, English)": "Email support (In Monta, English)",
    "Unlimited in team members": "Unlimited in team members",
    "Roaming: public charging for everyone":
      "Roaming: public charging for everyone",
    "Loading for other Monta users": "Loading for other Monta users",
    "Pay with your team Wallet": "Pay with your team Wallet",
    "Charging drops for team": "Charging drops for team",
    "Pay afterwards (per month)": "Pay afterwards (per month)",
    "Loading balancing": "Load balancing",

    // Plan details
    "Unlimited Team Members": "Unlimited Team Members",
    "Monthly Cost": "Monthly Cost",
    "Transaction Fee": "Transaction Fee",
    "Tech Support": "Tech Support",
    "24/7 Support": "24/7 Support",
    Portal: "Portal",
    Dashboard: "Dashboard",
    "Transaction Overview": "Transaction Overview",
    "Smart Queue": "Smart Queue",
    "Load Balancing": "Load Balancing",
    "Advanced Features": "Advanced Features",
    "Pay with team wallet": "Pay with team wallet",
    "Team charge keys": "Team charge keys",
    "Pay by invoice": "Pay by invoice",
    "Sponsored chargepoints": "Sponsored chargepoints",
    Roaming: "Roaming",
    "Enterprise security": "Enterprise security",

    // Chargepoint
    Chargepoint: "Chargepoint",
    "Search Serial Number": "Search Serial Number",
    "Add Sim": "Add Sim",
    "Additional €8/month per sim": "Additional €8/month per sim",
    Chargepoints: "Chargepoints",
    Connectors: "Connectors",
    Summary: "Summary",
    "Serial Number": "Serial Number",
    Model: "Model",
    "Max Power": "Max Power",

    // Company
    "Tax ID": "Tax ID",
    Company: "Company",
    Name: "Name",
    "Optional (for companies)": "Optional (for companies)",
    "Search Address": "Search Address",
    Street: "Street",
    City: "City",
    "Zip Code": "Postcode",
    Country: "Country",

    // Guidance text
    "Something went wrong, please try again":
      "Something went wrong, please try again",
    "Please enter a valid serial number": "Please enter a valid serial number",
    "Please add a chargepoint": "Please add a chargepoint",
    "Please enter a valid street": "Please enter a valid street",
    "Please enter a valid city": "Please enter a valid city",
    "Please enter a valid zip code": "Please enter a valid postcode",
    "Please enter a valid name": "Please enter a valid name",
    "Please enter a valid telephone number":
      "Please enter a valid telephone number",
    "Please enter a valid email": "Please enter a valid email",
    "Email address is already in use": "Email address is already in use",

    // The rest
    "Phone Number": "Phone Number",
    "Email Address": "Email Address",
    "Team Name": "Team Name",
    "Team Owner": "Team Owner",
    "Employee data": "Employee data",
    "Email address (this must be different from the company email address)":
      "Email address (this must be different from the company email address)",
    "Owner Name": "Owner Name",
    "Owner Telephone": "Owner Telephone",
    "Owner Email": "Owner Email",
    "Employer details": "Employer details",
    "Employer contact person": "Employer contact person",
    "Administration contact person": "Administration contact person",
    "Team Finance": "Team Finance",
    "Finance Name": "Finance Name",
    "Finance Telephone": "Finance Telephone",
    "Finance Email": "Finance Email",
    "Team Installer": "Team Installer",
    "Installer Name": "Installer Name",
    "Installer Telephone": "Installer Telephone",
    "Installer Email": "Installer Email",
    "Installation Notes (optional)": "Installation Notes (optional)",
    Site: "Site",
    "Private EV charger address": "Private EV charger address",
    "Site Name": "Site Name",
  },
};
